// Calculate age from date of birth
export const calculateAge = (dateOfBirth: string): number => {
    if(!dateOfBirth) {
        return 0; // Return 0 if no date of birth is provided
    }
    try{
        const birth = new Date(dateOfBirth);
        const today = new Date();
        let age = today.getFullYear() - birth.getFullYear();
        const monthDiff = today.getMonth() - birth.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
            age--;
        }
        return age;
    }catch {
        return 0; // Return 0 if any error occurs
    }

};